import {
  AfterContentInit,
  Component,
  ContentChild,
  ElementRef,
  Input,
  OnInit,
  QueryList, Renderer2,
  ViewChild,
  ContentChildren,
  EventEmitter,
  OnDestroy, AfterViewInit, Output,
} from '@angular/core';
import {SmartTableColumnDirective} from "./smart-table-column.directive";
import {ISort} from "../../../interfaces/sort";
import {ITableHeader} from '../../../interfaces/table-header';
import {SmartTableCollapseDirective} from "./smart-table-collapse.directive";
import {Subscription} from "rxjs";

@Component({
  selector: 'smart-table',
  templateUrl: './smart-table.component.html'
})
export class SmartTableComponent implements OnInit, OnDestroy, AfterViewInit, AfterContentInit {

  @ViewChild('header', {static: true}) headerEl: ElementRef;
  @ViewChild('content', {static: true}) contentEl: ElementRef;
  headerScroll: any;
  contentScroll: any;
  timeoutScroll: any;

  scrollConfig: any = {
    // wheelPropagation: true,
    // useBothWheelAxes: true,
  };

  source: any[] = [];
  collapses: CollapseControl[] = [];
  routers: string[][] = [];
  @Input() singleCollapsed: boolean = true;
  @Input('source') set source$(value: any) {
    if (!value) return;
    this.source = value;

    this.setCollapseControl();
    this.setRoutes();
    this.scrollTop();
  };
  @Input() navigate: any[];
  @Input('headers') set headers$(value: ITableHeader[]) {
    this.headers = value;
    this.isFiltration = this.headers.some(item => item.filter);
  }
  @Input() collapseByClick: boolean = false;
  @Input() collapseAuto: boolean = true;

  @ContentChildren(SmartTableColumnDirective) columns: QueryList<SmartTableColumnDirective>;
  @ContentChild(SmartTableCollapseDirective) collapseContent: SmartTableCollapseDirective;

  @Output() collapsedChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() collapsedAfterChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() filtersChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() sortChange: EventEmitter<any> = new EventEmitter<any>();

  headers: ITableHeader[];
  isFiltration: boolean;
  cells: any = {};
  routes: any = {};
  sort: ISort;


  constructor(private renderer: Renderer2) { }

  ngOnInit(): void {
  }

  get visibleHeaders() {
    return this.headers.filter(h => !h.hidden)
  }

  onChangeFilter(filter: any, item: ITableHeader) {
    this.filtersChange.emit(item)
  }

  onChangeSort(sort: any, item: ITableHeader) {
    if (sort?.direction)
      item.sort.direction = sort.direction;
    else
      delete item.sort.direction
    this.sortChange.emit(item)
  }

  ngOnDestroy() {
    if (this.headerScroll)
      this.headerScroll();

    if (this.contentScroll)
      this.contentScroll();

    if (this.singleCollapsed) {
      this.collapses.forEach(item => item.subscription.unsubscribe())
    }
  }

  ngAfterViewInit() {
    const callbackHeader = (e) => {
      if (this.timeoutScroll) clearTimeout(this.timeoutScroll);

      this.contentScroll();
      this.contentEl.nativeElement.scrollLeft = e.target.scrollLeft;

      this.timeoutScroll = setTimeout(() => {
        this.contentScroll = this.renderer.listen(this.contentEl.nativeElement, 'scroll', callbackContent);
      }, 100);
    };

    const callbackContent = (e) => {
      if (this.timeoutScroll) clearTimeout(this.timeoutScroll);

      this.headerScroll();
      this.headerEl.nativeElement.scrollLeft = e.target.scrollLeft;

      this.timeoutScroll = setTimeout(() => {
        this.headerScroll = this.renderer.listen(this.headerEl.nativeElement, 'scroll', callbackHeader);
      }, 100);
    };

    this.headerScroll = this.renderer.listen(this.headerEl.nativeElement, 'scroll', callbackHeader);
    this.contentScroll = this.renderer.listen(this.contentEl.nativeElement, 'scroll', callbackContent);
  }

  ngAfterContentInit() {
    this.columns.forEach(item => this.cells[item.key] = item);

    this.setCollapseControl();
    this.setRoutes();
  }

  setRoutes() {
    if (this.navigate) {
      this.routers = this.source.map(item => this.parserNavigate(item));
    }
  }

  setCollapseControl() {
    if (this.singleCollapsed) {
      this.collapses.forEach(item => item.subscription.unsubscribe())
    }

    this.collapses = [];

    if (this.collapseContent) {
      this.collapses = this.source.map((item, i) => {
        const control = new CollapseControl(i, this.collapsedChange, this.collapsedAfterChange);

        if (this.singleCollapsed) {
          control.subscription = control.collapsedAfterChange.subscribe((data) => {
            if (!data.result && i !== data.position)
              control.isCollapsed = true;
          });
        }

        return control;
      });
    }
  }

  scrollTop() {
    this.contentEl.nativeElement.scrollTop = 0;
  }

  parserNavigate(item) {
    if (!this.navigate) return;

    return (this.navigate as string[]).map((path: string) => {
      let p = path;
      if (p[0] === ':') {
        p = item[p.slice(1)];
      }

      return p;
    });
  }
}

export class CollapseControl {

  isCollapsed: boolean = true;
  position: number;
  subscription: Subscription;

  collapsedChange: EventEmitter<any>;
  collapsedAfterChange: EventEmitter<any>;

  constructor(position: number, collapsedChange: EventEmitter<any>, collapsedAfterChange: EventEmitter<any>) {
    this.position = position;
    this.collapsedChange = collapsedChange;
    this.collapsedAfterChange = collapsedAfterChange;
  }

  toggle(withUpdate = true) {
    this.change(!this.isCollapsed, withUpdate);
  }

  show(withUpdate = true) {
    this.change(false, withUpdate);
  }

  hide(withUpdate = true) {
    this.change(true, withUpdate);
  }


  private change(value: boolean, withUpdate = true) {
    const meta = {
      result: value,
      position: this.position,
    };

    if (withUpdate) {
      this.isCollapsed = value;
      this.collapsedAfterChange.emit({...meta})
    }

    this.collapsedChange.emit({
      ...meta,
      next: () => {
        this.isCollapsed = value;
        this.collapsedAfterChange.emit({...meta})
      }
    });
  }
}
